import { createReducer, on } from '@ngrx/store';
import { IValidateTokenRequest, IValidateTokenResponse } from '../models/validate-token.model';
import * as authActions from '../actions/validate-token.actions';

export const validateTokenFeatureKey = 'validateToken';

export interface ValidateTokenState {
  validateTokenRequest: IValidateTokenRequest | undefined;
  validateTokenResponse: IValidateTokenResponse | undefined;
  validateTokenFailure: Error | any;
}

export const initialState: ValidateTokenState = {
  validateTokenRequest: undefined,
  validateTokenResponse: undefined,
  validateTokenFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(authActions.loadValidateToken, (state, action) => ({
    ...state,
    validateTokenRequest: action.request
  })),
  on(authActions.loadValidateTokenSuccess, (state, action) => ({
    ...state,
    validateTokenResponse: action.response,
    validateTokenFailure: undefined
  })),
  on(authActions.loadValidateTokenFailure, (state, action) => ({
    ...state,
    validateTokenFailure: action.error
  }))
);

export const getValidateTokenResponse = (state: ValidateTokenState) => state.validateTokenResponse;
